;(function() {
  'use strict'

  angular.module('app.survey').filter('optionalSuffix', Filter)

  function Filter() {
    return function(string, shouldAdd, text) {
      if (shouldAdd) {
        var suffix = text ? ' (' + text + ')' : ' (Optional)'
        return string + suffix
      }
      return string
    }
  }
})()
